<template>
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Мониторинг изменений информации о контрагентах в ЕГРЮЛ.</span>
        </v-card-title>
        <v-card-text>
          Для мониторинга изменений, необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и мониторьте изменения в ЕГРЮЛ.
        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
        <v-flex xs12 md8 v-if="getProfileHaveClient && !getClientMonitoring">
      <v-card>
      <v-toolbar light dense flat >
        <v-toolbar-title>
          Мониторинг контрагентов в ЕГРЮЛ.
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-card-text>
          Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.
          Для активации этой функциональности нажмите кнопку "Включить". После активации все "Мои контрагенты" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" @click="switchMonitoringOn" >Включить</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getClientMonitoring">
      <v-monitoring-set></v-monitoring-set>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vMonitoringSet from './MonitoringSet.vue'

  export default {
    name: 'monitoring-panel',
    components: {vMonitoringSet},
    props: {
    },
    data: () => ({
      tagIds: []
    }),
    created () {
      this.fetchRights()
    },
    mounted () {
      this.fetchRights()
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getClientMonitoring: 'getClientMonitoring',
        getIsAllow: 'getIsAllow'
      })
    },
    methods: {
      switchMonitoringOn () {
        this.$store.dispatch('switchClientMonitoring', {monitoring: true, addFavorites: true})
      },
      fetchRights () {
        this.$store.dispatch('fetchRights', {MONITORING_SWITCH: null})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MonitoringPanel.vue?86e2d460